import { get, post, put, del } from "./ApiService";

const normalizeMemberId = (member) => {
  if (member === null || member === undefined) return "";
  if (typeof member !== "object") return String(member).trim();
  return String(
    member.user_id ??
      member.id ??
      member.member_id ??
      member.project_user_id ??
      member.userId ??
      member.uid ??
      ""
  ).trim();
};

export const getAllProjects = async () => {
  const response = await get("/projects");
  return response.projects || [];
};

export const addProject = async (projectData) => {
  const response = await post("/projects", projectData);
  return response;
};

export const getProjectMembers = async (projectId) => {
  try {
    const response = await get("/project_users", { project_id: projectId });
    return response.members || response.users || [];
  } catch {
    const response = await get(`/projects/${projectId}/members`);
    return response.users || response.members || [];
  }
};

export const removeMemberFromProject = async (projectId, userId) => {
  const payload = {
    project_id: projectId,
    uniq: projectId,
    uniq_id: projectId,
    user_id: userId,
    member_id: userId
  };
  const attempts = [
    () => del(`/projects/${projectId}/members/${userId}`, payload),
    () => del("/project_users", payload),
    () => del("/projects", payload)
  ];

  let lastError = null;

  for (const attempt of attempts) {
    const response = await attempt();
    if (response && response.status !== "error") {
      return response;
    }
    lastError = response;
  }

  throw new Error(lastError?.message || "Kullanıcı projeden çıkarılamadı.");
};

export const updateProjectMemberRole = async (projectId, userId, role) => {
  const memberId = normalizeMemberId(userId);
  const normalizedRole = String(role || "").trim().toLowerCase() === "manager" ? "manager" : "member";
  if (!memberId) {
    throw new Error("Kullanıcı id bulunamadı.");
  }

  const payload = {
    project_id: projectId,
    uniq: projectId,
    uniq_id: projectId,
    user_id: memberId,
    member_id: memberId,
    role: normalizedRole === "manager" ? "admin" : "member",
    member_role: normalizedRole,
    is_admin: normalizedRole === "manager" ? 1 : 0,
    is_manager: normalizedRole === "manager" ? 1 : 0,
    source: "web"
  };

  const attempts = [
    () => put("/project_users.php", payload),
    () => put("/project_users", payload)
  ];

  let lastError = null;

  for (const attempt of attempts) {
    try {
      const response = await attempt();
      if (response && response.status !== "error") {
        return response;
      }
      lastError = response;
    } catch (error) {
      lastError = error;
    }
  }

  throw new Error(
    lastError?.response?.data?.message ||
      lastError?.payload?.message ||
      lastError?.message ||
      "Kullanıcı rolü güncellenemedi."
  );
};
